<script lang="ts">
	import playIcon from "../assets/play.svg";
</script>

<button on:click class="icon-button" aria-label="play">
	<img class="icon" src={playIcon} alt="" />
</button>

<style>
	.icon-button {
		margin: 0;
		padding: 2em;
		border-radius: 50%;
		background: white;
		border: none;
	}

	.icon {
		height: 15em;
		width: 15em;
		animation: pulse 1.5s ease-in-out infinite;
	}

	@keyframes pulse {
		0%,
		100% {
			transform: scale(1);
		}
		50% {
			transform: scale(1.05);
		}
	}
</style>
